module.exports = __webpack_public_path__ + "static/img/not_found_data.4c7d36c8.png";